import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'ndtInitials',
    standalone: false
})
export class InitialsPipe implements PipeTransform {
   transform(name: string): string {
      return transformInitials(name);
   }
}

export function transformInitials(name: string): string {
   if (!name) {
      return name;
   }
   const clauses = removeNumericClauses(name.trim().split(' ')).map((clause) => {
      return clause.replace(/[^a-zA-Z ]/g, '');
   });

   if (clauses.length === 1 && clauses[0].length > 0) {
      return clauses[0].substr(0, 2);
   } else if (clauses.length > 1) {
      return `${clauses[0][0]}${clauses[clauses.length - 1][0]}`;
   } else {
      return name.trim().replace(/\D/g, '').substr(0, 2);
   }
}

function removeNumericClauses(clauses: string[]) {
   return clauses.filter((clause) => {
      return !clause.match(/\d+(st|nd|rd|th)/) && clause.match(/[a-zA-Z]/);
   });
}
